export default __webpack_public_path__ + "static/media/Icon-3.564c1731.svg";